export default "__VITE_ASSET__Bb9vP59F__"